import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import * as moment from 'moment';

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.scss']
})
export class MyAccountComponent implements OnInit {

  fields = ["Address_ThirdName","Contact_Name","Contact_FirstName","Address_Address1","Address_Address2","Address_Address3","Address_ZipCode","Address_CountryIsoCode","Address_City","Contact_Phone","Contact_CellPhone","Contact_Email"];

  dropdowns:any = {
    Address_CountryIsoCode: {options:"countries"}
  } 

  required = ["Address_ThirdName","Address_Address1","Address_ZipCode","Address_CountryIsoCode","Address_City"];

  activeMenu = 0;

  menu = [
  {label:"Profil", icon:'pi-user'},
  {label:"Mes adresses de livraison", icon:'pi-home'},
  {label:"Mon mot de passe", icon:'pi-lock'},
  ];

  newPass:any = {
  };

  customer:any = {};

  columns:any = {};
  colInfos:any = {};

  contacts:any;
  countries:any;

  constructor(public api:ApiService) { 
    this.newPass = {
      email: this.api.user.email,
      Id: this.api.user.Id
    };

  }

  ngOnInit(): void {
    this.api.postWS("sql=select",{fields:'IsoCode as value, Caption as label', database:'Country', where: 'Inactive = 0'}).then((res:any)=>{
      this.countries = res;
    });
    if(this.api.adminOrder)
        this.activeMenu = 1;
    this.refresh();
  }

  refresh(){

    this.columns = {};
    this.colInfos = {};

    let fields = "UseInvoicingAddressAsDeliveryAddress,Id,";
    for(let f of this.fields){
      fields += "MainInvoicing"+f+",MainDelivery"+f+",";
    }
    this.api.postWS("sql=select2",{fields:fields.slice(0, -1),database:"Customer",where:"Id = '"+this.api.user.Id+"'"}).then((res:any)=>{
      this.columns = {...this.columns,...res.columns};
      this.colInfos = {...this.colInfos,...res.colInfos};
      this.customer = res.data[0];
    });
    this.api.postWS("sql=select2",{fields:"*", database:"Contact", where:"AssociatedCustomerId = '"+this.api.user.Id+"' AND IsMainInvoicing = 0 AND IsMainDelivery = 0"}).then((res:any)=>{
      this.columns = {...this.columns,...res.columns};
      this.colInfos = {...this.colInfos,...res.colInfos};
      this.contacts = res.data ? [...res.data,{AddressFields_CountryIsoCode:'FR'}] : [{AddressFields_CountryIsoCode:'FR'}];

    });
  }

  saveAddress(form){
    if(form.value.UseInvoicingAddressAsDeliveryAddress === 1){
      for(let key in form.value){
        if(key.indexOf('Invoicing') > -1 && key != 'UseInvoicingAddressAsDeliveryAddress'){
          var key2 = key.replace('Invoicing','Delivery');
          form.value[key2] = form.value[key];
        }
      }
    }
    this.api.post("crm=modifAddress",{IdClient:this.customer['Id'],form:form.value}).then(res=>{
        if(res['status'] == 'success'){
            this.refresh();
            this.api.success('Les informations ont bien été enregistrées');
        }
    });
  }

  formatContactField(field){
    return field.replace("_","Fields_");
  }

  saveContact(form){
    let row = form.value;
    row.AssociatedCustomerId = this.api.user.Id;
    let f = "newContact";
    if(row.Id != undefined){
      f = "update";
    }
    //console.log(row);
    this.api.postWS("contact="+f,row).then(res=>{
      this.refresh();
    });
  }

  deleteContact(row){
    this.api.confirm("Etes-vous certain de vouloir supprimer cette adresse").then(res=>{
      if(res){
        this.api.postWS("contact=delete",{Id:row.Id}).then(res=>{
          this.refresh();
        });
      }
    })
  }

  savePass(){
    this.api.post("pro=changePassword",this.newPass).then((res:any)=>{
      if(res.statut == 'ok'){
        this.api.success("Mot de passe enregistré");
      }else{
        this.api.error("Une erreur a eu lieu. Merci de recharger la page");
      }
    });
  }



}
